import clsx from "clsx"
import { Link } from "gatsby"
import * as React from "react"

export default function LinkBtn({ link, className }) {

  if (link.url.startsWith('http')) {
    return (
      <a
        href={link.url}
        target={link.target}
        className={clsx("btn", className)}
        rel="noreferrer noopener"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 5.92 10.02"
          width="6"
        >
          <polygon
            fill="currentColor"
            points=".67 10.02 0 9.29 4.5 5.18 .39 .67 1.13 0 5.92 5.24 .67 10.02"
          />
        </svg>
        <span className="translate-y-px">{link.title}</span>
      </a>
    )
  }

  return (
    <Link
      to={link.url}
      className={clsx("btn", className)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 5.92 10.02"
        width="6"
      >
        <polygon
          fill="currentColor"
          points=".67 10.02 0 9.29 4.5 5.18 .39 .67 1.13 0 5.92 5.24 .67 10.02"
        />
      </svg>
      <span className="translate-y-px">{link.title}</span>
    </Link>
  )
}
